export function paginator(object, perPageSize, pageNo) {
    const paginated = object.slice((pageNo - 1) * perPageSize, (pageNo * perPageSize))
    return paginated
}

export function renderPages(objectSize, perPageSize) {
    const totalPages = Math.ceil(objectSize / perPageSize);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    return pages;
}

export function getNews(object, id) {
    let newsObject = object.filter(obj => id === obj.id);
    const returnObject = newsObject[0];
    return returnObject;
}